import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AvanzadoPlantaComponent } from "../../../components/Avanzados/AvanzadoPlantas";

export const AvanzadoPlantaPage: React.FC = () => {
    const navigate = useNavigate();

    const {userData } = useAppSelector((state) => state.authReducer)


    //Si no es administrador no permite ingresar
    React.useEffect(() => {
        if(userData?.role !== "ADMIN")
            {
                navigate('/');
            }
    },[userData, navigate])

    return (
        <Container 
            maxWidth={false} 
            sx={{
                px: 2, // padding horizontal: 2*8px = 16px
            }}
        > 
         {/*   <HeaderComponent 
                title="Control Avanzado"
                description= ""
                //element={<Button fullWidth variant="contained" onClick ={()=> navigate("/")} >Ir a Lista de Frigorificos</Button>}
            />*/}
            <AvanzadoPlantaComponent />

        </Container>
    )

}